import {
    createVNode as _$cv,
    className as _$cn,
    createUnknownComponentVNode as _$cc,
    createElementVNode as _$ce,
    map as _$ma,
} from 'intact';
import {makeStyles} from './styles';
import {TourStep} from './step';
import {TourContext} from './tour';
import {getRestProps, stopPropagation} from '../utils';
import {mapChildren, isComponentVNode} from '../utils';


export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    
    const { className, data, children, value, hoverable,
        showArrow, theme, visible, maskClosable,
        doneText, closable,
    } = this.get();
    const { k } = this.config;
    
    const currentValue = value !== undefined ? value : 0;
    const {arrowType, arrowRef} = this.arrow;
    const {highlightRef} = this.highlight;
    const {prev, next, finish} = this.navigation;
    const {getTotalSteps} = this.steps;
    
    const contextValue = {
        value: value || 0,
        total: getTotalSteps(),
        doneText: doneText,
        closable: closable,
        onPrev: prev,
        onNext: next,
        onFinish: finish
    }
    
    const classNameObj = {
        [`${k}-tour`]: true,
        [`${k}-${theme}`]: true,
        [className]: className,
        [makeStyles(k)]: true,
    };
    
    return (visible) ?
        _$cv('div', {
            'className': _$cn(classNameObj),
            ...getRestProps(this)
        }, (
            _$cc(TourContext.Provider, {
                'value': contextValue,
                'children': [
                    null,
                    (currentValue !== undefined) ?
                        _$ce(2, 'div', null, 1 /* HasInvalidChildren */, _$cn({
                            [`${k}-tour-target-highlight`]: true,
                            [`${k}-hoverable`]: hoverable
                        }), null, null, highlightRef) :
                        undefined,
                    null,
                    _$ce(2, 'div', [
                        (!children) ?
                            (
                                _$ma(data, function($value, $key) {
                                    return ($key === currentValue) ?
                                        _$cc(TourStep, {
                                            'key': $key,
                                            ...$value
                                        }, $key) :
                                        undefined;
                                }, $this)
                            ) :
                            mapChildren(children, (vNode, index) => {
                                if (isComponentVNode(vNode, TourStep)) {
                                    if (index === currentValue) {
                                        return vNode;
                                    }
                                }
                                return null;
                            }),
                        null,
                        (showArrow && arrowType.value) ?
                            _$ce(2, 'i', null, 1 /* HasInvalidChildren */, _$cn({
                                [`${k}-tour-arrow`]: true,
                                [`${k}-${arrowType.value}`]: arrowType.value,
                            }), null, null, arrowRef) :
                            undefined
                    ], 0 /* UnknownChildren */, _$cn(`${k}-tour-step-wrapper`), {
                        'ev-click': stopPropagation
                    }, null, this.tourRef)
                ]
            })
        )) :
        undefined;
};